// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet vragen-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfVragenSbiCodesSbiCodeDto } from '../model/collectionResultOfVragenSbiCodesSbiCodeDto.ts';

import type { Result1OfVragenSbiCodesSbiBeschrijvingDto } from '../model/result1OfVragenSbiCodesSbiBeschrijvingDto.ts';

import type { SbiCodesGetSbiCodesParams } from '../model/sbiCodesGetSbiCodesParams.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const sbiCodesGetSbiCodes = (
  params?: MaybeRefOrGetter<SbiCodesGetSbiCodesParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfVragenSbiCodesSbiCodeDto>(
    { url: `/api/v1/sbicodes`, method: 'GET', params, signal },
    options,
  );
};

export const getSbiCodesGetSbiCodesQueryKey = (
  params?: MaybeRefOrGetter<SbiCodesGetSbiCodesParams>,
) => {
  return ['api', 'v1', 'sbicodes', ...(params ? [params] : [])] as const;
};

export const getSbiCodesGetSbiCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<SbiCodesGetSbiCodesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSbiCodesGetSbiCodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>> = ({ signal }) =>
    sbiCodesGetSbiCodes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>,
    TError,
    TData
  >;
};

export type SbiCodesGetSbiCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>
>;
export type SbiCodesGetSbiCodesQueryError = ErrorType<void>;

export function useSbiCodesGetSbiCodes<
  TData = Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<SbiCodesGetSbiCodesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sbiCodesGetSbiCodes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSbiCodesGetSbiCodesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const sbiCodesSbiBeschrijving = (
  sbiCode: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  sbiCode = toValue(sbiCode);

  return customInstance<Result1OfVragenSbiCodesSbiBeschrijvingDto>(
    { url: `/api/v1/sbicodes/${sbiCode}`, method: 'GET', signal },
    options,
  );
};

export const getSbiCodesSbiBeschrijvingQueryKey = (
  sbiCode: MaybeRefOrGetter<string | undefined | null>,
) => {
  return ['api', 'v1', 'sbicodes', sbiCode] as const;
};

export const getSbiCodesSbiBeschrijvingQueryOptions = <
  TData = Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>,
  TError = ErrorType<void>,
>(
  sbiCode: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSbiCodesSbiBeschrijvingQueryKey(sbiCode);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>> = ({
    signal,
  }) => sbiCodesSbiBeschrijving(sbiCode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(sbiCode) !== null && toValue(sbiCode) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>, TError, TData>;
};

export type SbiCodesSbiBeschrijvingQueryResult = NonNullable<
  Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>
>;
export type SbiCodesSbiBeschrijvingQueryError = ErrorType<void>;

export function useSbiCodesSbiBeschrijving<
  TData = Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>,
  TError = ErrorType<void>,
>(
  sbiCode: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sbiCodesSbiBeschrijving>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSbiCodesSbiBeschrijvingQueryOptions(sbiCode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
